import axios from '../../../api';
import { UserSearchResult } from '../../../api/users';

export interface CurrentImpersonation {
  isImpersonating: boolean;
  admin?: { wwid: number; name: string } | null;
  target?: UserSearchResult | null;
}

export const startImpersonation = async (targetWwid: number) => {
  const response = await axios.post('/impersonation', { targetWwid });
  return response.data;
};

export const stopImpersonation = async () => {
  const response = await axios.delete('/impersonation');
  return response.data;
};

export const getCurrentImpersonation = async (): Promise<CurrentImpersonation> => {
  const response = await axios.get('/impersonation/current');
  return response.data;
};
